import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const UpdateUserInformationLazy = lazyLoader(
  () =>
    import(
      './UpdateUserInformation' /* webpackChunkName: "update-user-information" */
    ),
);

const UpdateUserInformation = () => {
  return (
    <Suspense fallback={null}>
      <UpdateUserInformationLazy />
    </Suspense>
  );
};

export default UpdateUserInformation;
